import React from 'react';

type Props = any;

const BookmarkAppExtensionEditor = (props: Props) => {
  return <div>BookmarkAppExtensionEditor</div>;
};

export default BookmarkAppExtensionEditor;
